var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mx-0",attrs:{"fluid":_vm.fluid}},[_c('v-row',{attrs:{"justify":_vm.justifyCenter ? 'center' : null}},[_c('v-col',{attrs:{"sm":"12","lg":!_vm.fluid ? 10 : null,"xl":!_vm.fluid ? 8 : null}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }